import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import { Award, FileText, RefreshCcw, Users, MessageSquare, Phone } from 'lucide-react';

const Freebies = () => {
  const features = [
    {
      icon: <Award />,
      title: "Best Assignment Expert Assigned",
    },
    {
      icon: <FileText />,
      title: "Cover Page and Citations",
    },
    {
      icon: <FileText />,
      title: "Formatting in Any Academic Style",
    },
    {
      icon: <Users />,
      title: "Unlimited Sources Included",
    },
    {
      icon: <RefreshCcw />,
      title: "Unlimited Revisions",
    },
    {
      icon: <MessageSquare />,
      title: "Direct Chat with Expert",
    }
  ];

  return (
    <div className="w-full bg-slate-50 py-6 sm:py-8 md:py-12 px-4 sm:px-6 md:px-8">
      <Card sx={{ 
        maxWidth: { xs: '100%', lg: '1200px' }, 
        margin: 'auto',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
      }}>
        <CardContent sx={{ 
          backgroundColor: '#234152', 
          color: 'white',
          borderTopLeftRadius: '0.5rem',
          borderTopRightRadius: '0.5rem',
          textAlign: 'center',
          padding: { xs: '1.5rem', sm: '2rem' }
        }}>
          <Typography 
            variant="h4" 
            component="h2" 
            sx={{ 
              fontWeight: 'bold', 
              marginBottom: 1,
              fontSize: { xs: '1.5rem', sm: '1.875rem', md: '2.25rem' }
            }}
          >
            Free Features
          </Typography>
          <Typography 
            variant="body1" 
            sx={{ 
              color: '#cbd5e1',
              fontSize: { xs: '0.875rem', sm: '1rem' },
              maxWidth: '600px',
              margin: '0 auto'
            }}
          >
            All these premium features are included in your package
          </Typography>
        </CardContent>

        <CardContent sx={{ 
          padding: { xs: '1rem', sm: '1.5rem', md: '2rem' },
          '&:last-child': { paddingBottom: { xs: '1.5rem', sm: '2rem' } }
        }}>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 md:gap-6">
            {features.map((feature, index) => (
              <div 
                key={index}
                className="group flex items-center space-x-3 sm:space-x-4 p-3 sm:p-4 rounded-lg bg-white border border-slate-200 hover:border-slate-300 hover:shadow-md transition-all duration-300"
              >
                <div className="p-2 rounded-lg bg-slate-100 group-hover:bg-slate-900 group-hover:text-white transition-colors duration-300 flex-shrink-0">
                  {React.cloneElement(feature.icon, { 
                    className: "w-5 h-5 sm:w-6 sm:h-6" 
                  })}
                </div>
                <Typography 
                  variant="body1" 
                  sx={{ 
                    fontWeight: 500, 
                    color: '#334155',
                    fontSize: { xs: '0.875rem', sm: '1rem' },
                    lineHeight: 1.4
                  }}
                >
                  {feature.title}
                </Typography>
              </div>
            ))}
          </div>

          <div className="mt-8 sm:mt-10 md:mt-12 text-center">
            <button className="inline-flex items-center gap-2 bg-green-600 text-white font-semibold py-2.5 sm:py-3 px-5 sm:px-6 rounded-lg transition-colors duration-300 text-sm sm:text-base">
              <Phone className="w-4 h-4 sm:w-5 sm:h-5" />
              Contact Us on WhatsApp
            </button>
            <Typography 
              variant="body2" 
              sx={{ 
                color: '#64748b', 
                marginTop: { xs: 1, sm: 1.5 },
                fontSize: { xs: '0.75rem', sm: '0.875rem' }
              }}
            >
              Fast, secure, and confidential
            </Typography>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Freebies;